(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["million-home-edit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('million-home-tabs')) {
    customElements.define('million-home-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.querySelector('[data-tab-controls]').hidden = false;
        const tabs = [...this.querySelectorAll('[data-home-tab]')];
        const select = (value) => {
          tabs.forEach(tab => tab.setAttribute('aria-pressed', String(tab.dataset.homeTab === value)));
          this.querySelectorAll('[data-home-panel]').forEach(panel => { panel.hidden = panel.dataset.homePanel !== value; });
        };
        select(tabs[0].dataset.homeTab);
        tabs.forEach(tab => tab.addEventListener('click', () => select(tab.dataset.homeTab)));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["million-layer-demo"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('million-layer-demo'))customElements.define('million-layer-demo',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';this.querySelectorAll('[data-quantity]').forEach(button=>button.addEventListener('click',()=>{const quantity=Number(button.dataset.quantity);const discount=quantity>=3?10:quantity===2?5:0;this.querySelector('[data-discount]').textContent=discount+'%';this.querySelector('[data-progress]').style.width=(discount*10)+'%';this.querySelectorAll('[data-quantity]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)))}))}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('million-recently-viewed')) {
  customElements.define('million-recently-viewed', class extends HTMLElement {
    connectedCallback() { this.loadProducts(); }
    disconnectedCallback() { this.controller?.abort(); }
    async loadProducts() {
      this.controller?.abort();
      this.controller = new AbortController();
      const controller = this.controller;
      this.hidden = true;
      try {
        const stored = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]');
        const excluded = Number(this.getAttribute('exclude-id'));
        const count = Math.min(24, Math.max(2, Number(this.getAttribute('products-count')) || 6));
        const ids = [...new Set((Array.isArray(stored) ? stored : []).map(Number))]
          .filter(id => Number.isSafeInteger(id) && id > 0 && id !== excluded).slice(0, count);
        if (!ids.length) return;
        const sectionId = this.closest('.shopify-section').id.replace(/^shopify-section-/, '');
        const url = new URL(Shopify.routes.root + 'search', location.origin);
        url.search = new URLSearchParams({type: 'product', q: ids.map(id => 'id:' + id).join(' OR '), section_id: sectionId});
        const response = await fetch(url, {signal: controller.signal, priority: 'low'});
        if (!response.ok) return;
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = document.querySelector('million-recently-viewed');
        if (controller.signal.aborted || !this.isConnected || !content?.querySelector('product-card')) return;
        this.replaceChildren(...content.childNodes);
        this.hidden = false;
      } catch (error) {}
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
